import React, { useState } from 'react'
import { BarsOutlined, DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import cloneDeep from 'lodash/cloneDeep'

/**
 * ExampleComponent is an example component.
 * It takes a property, `label`, and
 * displays it.
 * It renders an input with the property `value`
 * which is editable by the user.
 */
const ArrayParams = (props) => {
    const { isEdit, value, setValue } = props

    const changeKey = (index, key) => {
        const currentValue = cloneDeep(value)
        currentValue[index] = { [key]: Object.values(value[index])[0] }
        setValue(currentValue)
    }

    const changeValue = (index, key) => {
        const currentValue = cloneDeep(value)
        currentValue[index] = { [Object.keys(value[index])[0]]: key }
        setValue(currentValue)
    }

    // 改变数据类型
    const changeType = (index, key) => {
        const currentValue = cloneDeep(value)
        if (key === 'number') {
            if (isNaN(Number(Object.values(value[index])[0]))) {
                currentValue[index] = { [Object.keys(value[index])[0]]: 0 }
            } else {
                currentValue[index] = { [Object.keys(value[index])[0]]: Number(Object.values(value[index])[0]) }
            }
        } else if (key === 'boolean') {
            currentValue[index] = { [Object.keys(value[index])[0]]: Boolean(Object.values(value[index])[0]) }
        } else {
            currentValue[index] = { [Object.keys(value[index])[0]]: String(Object.values(value[index])[0]) }
        }
        setValue(currentValue)
    }

    // 当前数据
    const [currentKey1, setCurrentKey1] = useState('')
    const [currentKey2, setCurrentKey2] = useState('')
    const addData = () => {
        const currentValue = cloneDeep(value)
        currentValue.push({ [currentKey1]: currentKey2 })
        setValue(currentValue)
        setCurrentKey1('')
        setCurrentKey2('')
    }

    // 改变数据类型
    const changeCurrentType = (key) => {
        console.log('key', key);
        if (key === 'number') {
            if (isNaN(Number(currentKey2))) {
                setCurrentKey2(0)
            } else {
                setCurrentKey2(Number(currentKey2))
            }
        } else if (key === 'boolean') {
            setCurrentKey2(Boolean(currentKey2))
        } else {
            setCurrentKey2(String(currentKey2))
        }
    }

    return (
        // 参数
        <div className='h-params flex flex-col'>
            <div className='flex border-y'>
                <div className='w-10 border-x px-2 p-1'></div>
                <div className='flex-1 border-r px-2 py-1'>Key</div>
                <div className='flex-1 border-r px-2 py-1'>Value</div>
                <div className='flex-1 border-r px-2 py-1'>Type</div>
            </div>
            {value.map((item, index) => (
                <div className='flex border-b'>
                    <div className='w-10 border-x px-2 p-1 flex justify-center items-center cursor-pointer  text-gray-400'>
                        <BarsOutlined />
                    </div>
                    <div className='flex-1 border-r px-2 py-1'>
                        <input disabled={!isEdit} type='text' placeholder='添加键' className='form-control form-control-sm flex-1' value={Object.keys(item)[0]}
                            onChange={(e) => changeKey(index, e.target.value)}>
                        </input>
                    </div>
                    <div className='flex-1 border-r px-2 py-1 flex items-center'>
                        <input disabled={!isEdit} type='text' placeholder='添加值' className='form-control form-control-sm flex-1' value={Object.values(item)[0]}
                            onChange={(e) => changeValue(index, e.target.value)}>
                        </input>
                    </div>
                    <div className='flex-1 border-r px-2 py-1 flex justify-between items-center'>
                        <select disabled={!isEdit} className="form-select form-select-sm" value={typeof Object.values(item)[0]}
                            onChange={(e) => changeType(index, e.target.value)}>
                            <option disabled value="">请选择类型</option>
                            <option>string</option>
                            <option>number</option>
                            <option>boolean</option>
                        </select>
                        {isEdit && <div className='cursor-pointer ml-2 text-gray-500' onClick={() => {
                            const currentValue = cloneDeep(value)
                            currentValue.splice(index, 1)
                            setValue(currentValue)
                        }}> <DeleteOutlined /></div>}
                    </div>
                </div>
            ))}
            <div className='flex border-b'>
                <div className='w-10 border-x px-2 p-1 flex justify-center items-center cursor-pointer  text-gray-400'>
                    <BarsOutlined />
                </div>
                <div className='flex-1 border-r px-2 py-1'>
                    <input type='text' placeholder='添加键' className='form-control form-control-sm flex-1' value={currentKey1} onChange={e => setCurrentKey1(e.target.value)}></input>
                </div>
                <div className='flex-1 border-r px-2 py-1 flex items-center'>
                    <input type='text' placeholder='添加值' className='form-control form-control-sm flex-1 mr-2' value={currentKey2} onChange={e => setCurrentKey2(e.target.value)}></input>
                </div>
                <div className='flex-1 border-r px-2 py-1 flex justify-between items-center'>
                    <select className="form-select form-select-sm" value={typeof currentKey2}
                        onChange={(e) => changeCurrentType(e.target.value)}>
                        <option disabled={!isEdit} value="">请选择类型</option>
                        <option>string</option>
                        <option>number</option>
                        <option>boolean</option>
                    </select>
                    {isEdit && <div className='cursor-pointer text-gray-500' onClick={addData}> <PlusCircleOutlined /></div>}
                </div>
            </div>
        </div>
    )
}

ArrayParams.defaultProps = {};

ArrayParams.propTypes = {
    /**
     * bool
     */
    isEdit: PropTypes.bool,

    /**
     * array
     */
    value: PropTypes.array,

    /**
     * array
     */
    setValue: PropTypes.func
};

export default ArrayParams;
